export default __webpack_public_path__ + "static/media/offer-icon-published.577de798.svg";